import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import "./i18n";
import { configureStore } from "./store/store";
import * as serviceWorker from './serviceWorker';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Provider store={configureStore({})}>
        <Router>
            <App />
        </Router>
    </Provider>
);
reportWebVitals();

// Register the service worker with the update callback
serviceWorker.register({
    onUpdate: registration => {
        // When there's an update, show a notification to the user
        const waitingServiceWorker = registration.waiting;
        if (waitingServiceWorker) {
            waitingServiceWorker.addEventListener("statechange", event => {
                if (event.target.state === "activated") {
                    if (window.confirm("New version available! Click OK to refresh.")) {
                        window.location.reload();
                    }
                }
            });
            waitingServiceWorker.postMessage({ type: "SKIP_WAITING" });
        }
    }
});